import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const BankForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});

  const [accountGroups, setAccountGroups] = useState([]);
  const [accountGroupId, setAccountGroupId] = useState(0);

  const [accountSubGroups, setAccountSubGroups] = useState([]);
  const [accountSubGroupId, setAccountSubGroupId] = useState(0);

  const { sendRequest: getAccountGroups } = useHttp();

  useEffect(() => {
    getAccountGroups(
      {
        url: `/api/accountGroup/?accountHead=Asset&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log(data);
        setAccountGroups(data);
      }
    );
  }, [getAccountGroups]);

  const { sendRequest: getAccountSubGroups } = useHttp();

  useEffect(() => {
    getAccountSubGroups(
      {
        url: `/api/accountSubGroup/?accountGroupId=${accountGroupId}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setAccountSubGroups(res);
        }
      }
    );
  }, [accountGroupId]);

  const { sendRequest: postBank } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      bankAccountName: frmRef.current.bankAccountName.value.trim(),
      bankAccountCode: frmRef.current.bankAccountCode.value.trim(),
      IFSCCode: frmRef.current.IFSCCode.value.trim(),
      accountGroupId: frmRef.current.acc_group.value.trim(),
      accountSubGroupId: frmRef.current.acc_sub_group.value.trim(),
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
    };
   // console.log(data);

    postBank(
      {
        url: "/api/bankDetail/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        var error = false;
        var msg = `Account group detail ${props.update ? "updated" : "added"} `;
        if (data == "Account group name/code already present") {
          msg = `Account group name/code already present`;
          error = true;
        }
        toast.success(msg);
        props.addForm(error);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Bank Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bank Account Name</label>

                        <input
                          type={"text"}
                          id={"bankAccountName"}
                          ref={(el) => (frmRef.current["bankAccountName"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bank Account Code </label>

                        <input
                          type={"text"}
                          id={"BankAccountCode"}
                          ref={(el) => (frmRef.current["bankAccountCode"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>IFSC Code </label>

                        <input
                          type={"text"}
                          id={"IFSCCode"}
                          ref={(el) => (frmRef.current["IFSCCode"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Group</label>

                        <select
                          id="acc_group"
                          className="form-control dropdowns"
                          ref={(el) => (frmRef.current["acc_group"] = el)}
                          required
                          value={accountGroupId}
                          onChange={(e) => {
                            setAccountGroupId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {accountGroups &&
                          accountGroups.map((x) => (
                            <option
                              value={x.accountGroupId}
                             
                            >
                              {x.accountGroupName}
                            </option>
                          ))}
                        </select>
                      </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Account Sub Group</label>

                          <select
                            id="acc_sub_group"
                            className="form-control dropdowns"
                            ref={(el) => (frmRef.current["acc_sub_group"] = el)}
                            required
                            value={accountSubGroupId}
                            onChange={(e) => {
                              setAccountSubGroupId(e.target.value);
                            }}
                          >
                            <option value="">Select</option>
                            {accountSubGroups &&
                          accountSubGroups.map((x) => (
                            <option
                              value={x.accountSubGroupId}
                             
                            >
                              {x.accountSubGroupName}
                            </option>
                          ))}
                          </select>
                        </div>
                      </div>
                  
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default BankForm;
